const checkboxGroupContextKey = Symbol("checkboxGroupContextKey");

export { checkboxGroupContextKey };
//# sourceMappingURL=constants.mjs.map
